import React,{useContext} from 'react';
import '../Styles/MobileBreadCrumb.scss';
import { GlobalContext } from '../Contexts/GlobalContext';
import useGuiTranslations from './MultiLanguage/useGuiTranslations';

export default function MobileBreadCrumb(props) {
    const [translateGui] = useGuiTranslations();
    const globalContext = useContext(GlobalContext);

    return (
        <div className="mobile-bread-crumb ilk-harf-buyuk">
            {translateGui(globalContext.globalState.menuLocation.b)}
        </div>
    )
}